const steps = [
  {
    number: "01",
    icon: "ri-discuss-line",
    title: "Consultation",
    description: "Discuss your vision, property layout, and project goals. We listen first, then plan.",
  },
  {
    number: "02",
    icon: "ri-draft-line",
    title: "Planning",
    description: "Scope the project with structural considerations, material selection, and clear timelines.",
  },
  {
    number: "03",
    icon: "ri-hammer-line",
    title: "Build",
    description: "Precision construction with attention to detail, structural integrity, and clean finishes.",
  },
  {
    number: "04",
    icon: "ri-checkbox-circle-line",
    title: "Final Walkthrough",
    description: "We walk through every detail together to ensure quality, alignment, and your complete satisfaction.",
  },
];

export default function ProcessSection() {
  return (
    <section id="process" className="w-full bg-white py-28 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className="text-stone-400 text-xs uppercase tracking-[0.28em] font-medium block mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            How We Work
          </span>
          <h2
            className="text-stone-900 font-semibold"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(2.2rem, 4vw, 3.2rem)" }}
          >
            A Streamlined <span className="font-light italic">Build Process</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-8 left-[calc(12.5%+16px)] right-[calc(12.5%+16px)] h-px bg-stone-100 z-0" />

          {steps.map((step, idx) => (
            <div key={idx} className="flex flex-col items-center text-center relative z-10 group">
              {/* Icon circle */}
              <div className="w-16 h-16 rounded-full border-2 border-stone-200 bg-white flex items-center justify-center mb-6 group-hover:border-stone-800 group-hover:bg-stone-900 transition-all duration-400">
                <i className={`${step.icon} text-stone-400 text-xl group-hover:text-white transition-colors duration-400`}></i>
              </div>

              {/* Step number */}
              <span
                className="text-stone-200 text-xs font-semibold tracking-[0.2em] mb-2 uppercase"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {step.number}
              </span>

              <h3
                className="text-stone-900 font-semibold text-xl mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {step.title}
              </h3>
              <p
                className="text-stone-500 text-sm leading-relaxed max-w-[220px]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
